export class TicketsDataOtherTickets { 
    name:string|{ [lang:string]: string };
    price: number;
}

export class TicketsData {
    
    fullPrice:number = null;

    otherTickets:Array<TicketsDataOtherTickets> =[];

    constructor(fromData?:any) {
        if(fromData != null) {
            if(typeof fromData == 'string') {
                fromData = JSON.parse(fromData);
            }
    
            for(let i in fromData) {
                this[i] = fromData[i];
            }
        }
    }

    toData() {
        
        return JSON.stringify({
            fullPrice: this.fullPrice,
            otherTickets: this.otherTickets
        })
    }
}